export default __webpack_public_path__ + "static/media/5.5252bf26.jpg";